var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"futuristic-app"},[_c('v-main',[_c('v-container',{staticClass:"pa-4 pa-md-6 pa-lg-8",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }